import React from 'react';
import { Lock } from 'lucide-react';
export function LikesYouSection() {
  return <div className="mb-8" data-id="element-227">
      <div className="flex items-center justify-between px-2 mb-4" data-id="element-228">
        <h2 className="text-lg font-bold text-zinc-900" data-id="element-229">Likes You</h2>
        <span className="text-sm font-bold text-rose-500" data-id="element-230">See all (12)</span>
      </div>

      <div className="relative overflow-hidden rounded-2xl bg-zinc-900 aspect-[2/1]" data-id="element-231">
        {/* Blurred Background Grid */}
        <div className="absolute inset-0 grid grid-cols-4 gap-1 opacity-50" data-id="element-232">
          {[...Array(8)].map((_, i) => <div key={i} className="bg-zinc-700 w-full h-full relative overflow-hidden" data-id="element-233">
              <img src={`https://images.unsplash.com/photo-${1500000000000 + i}?w=200&h=200&fit=crop`} alt="" className="w-full h-full object-cover blur-md" data-id="element-234" />
            </div>)}
        </div>

        {/* Overlay Content */}
        <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/40 backdrop-blur-[2px]" data-id="element-235">
          <div className="w-12 h-12 rounded-full bg-rose-500 flex items-center justify-center mb-3 shadow-lg shadow-rose-500/30" data-id="element-236">
            <Lock size={20} className="text-white" data-id="element-237" />
          </div>
          <h3 className="text-white font-bold text-lg mb-1" data-id="element-238">
            See who likes you
          </h3>
          <p className="text-white/80 text-xs mb-4" data-id="element-239">
            Upgrade to Gold to see them now
          </p>
          <button className="px-6 py-2 bg-white text-zinc-900 rounded-full text-sm font-bold hover:bg-zinc-100 transition-colors" data-id="element-240">
            Get Premium
          </button>
        </div>
      </div>
    </div>;
}